



























































































































import Vue from 'vue';
import { mapActions, mapGetters } from 'vuex';

import { ITag } from '@/models/configurator';
import { DataTableHeader } from 'vuetify';
import { ISystemError } from '@/models/error/error.types';

import { setErrorFromAxiosError } from '@/utils/helpers';

import ALPage from '@/components/core/Page/ALPage.vue';
import QuestionTagFormDialog from '@/components/configurator/question/QuestionTagFormDialog.vue';
import ErrorAlert from '@/components/common/ErrorAlert.vue';
import ConfirmationDialog from '@/components/common/ConfirmationDialog.vue';

interface Options extends InstanceType<typeof Vue> {
  $refs: {
    questionTagFormDialog: InstanceType<typeof QuestionTagFormDialog>;
  };
}

export default Vue.extend<Options>({ functional: false }).extend({
  components: {
    ErrorAlert,
    QuestionTagFormDialog,
    ConfirmationDialog,
    ALPage
  },

  data() {
    return {
      search: '',
      isLoading: false,

      error: null as ISystemError | null,
      deleteError: null as ISystemError | null,

      options: {
        showFirstLastPage: true,
        itemsPerPageOptions: [100]
      },
      page: 1,

      deleteInProgress: false,
      deleteDialog: false,
      selectedTag: null as null | ITag
    };
  },

  computed: {
    ...mapGetters({
      tags: 'configuratorQuestion/getTags'
    }),

    tagHeaders(): DataTableHeader[] {
      return [
        {
          text: 'Name',
          align: 'start',
          sortable: false,
          value: 'name'
        },
        { text: '', value: 'actions', width: 80 },
        {
          text: '',
          value: 'spacer',
          sortable: false,
          width: 50
        }
      ];
    }
  },

  mounted() {
    this.isLoading = true;
    this.fetchTags()
      .catch(error => {
        this.error = setErrorFromAxiosError(error);
      })
      .finally(() => {
        this.isLoading = false;
      });
  },

  methods: {
    ...mapActions({
      fetchTags: 'configuratorQuestion/fetchTags',
      deleteTag: 'configuratorQuestion/deleteTag'
    }),

    clearErrors(): void {
      this.error = null;
    },

    clearDeleteError(): void {
      this.deleteError = null;
    },

    createTag() {
      this.$refs.questionTagFormDialog.open();
    },

    editRecord(tag: ITag) {
      this.$refs.questionTagFormDialog.open(tag);
    },

    deleteRecord(tag: ITag) {
      this.clearErrors();
      this.selectedTag = tag;
      this.deleteDialog = true;
    },

    cancelTagDeleteDialog() {
      this.selectedTag = null;
      this.deleteDialog = false;
    },

    removeTag(tag: ITag) {
      this.clearDeleteError();
      this.deleteInProgress = true;

      this.deleteTag(tag.id)
        .then(() => {
          this.deleteDialog = false;
        })
        .catch(error => {
          this.deleteError = setErrorFromAxiosError(error);
        })
        .finally(() => {
          this.deleteInProgress = false;
        });
    }
  }
});
